import { DollarRate } from "@/services/getDollarValue";
import { LanguageProviderContext } from "@/providers/LanguageProvider";
import * as Dialog from "@radix-ui/react-dialog";
import { X, ArrowUpDown } from "lucide-react";


import { useContext, useEffect } from "react";

interface ExchangeRateModalProps {
  rate: DollarRate | null;
  loading: boolean;
  onRefresh: () => void;
}

export const ExchangeRateModal = ({ rate, onRefresh }: ExchangeRateModalProps) => {
  const { translator } = useContext(LanguageProviderContext);
  useEffect(() => {
    if (onRefresh) {
      onRefresh();
    }
  }, []);

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <button
          className="flex items-center gap-1 px-3 py-2 text-sm border border-input bg-background hover:bg-accent hover:text-accent-foreground rounded-md transition-colors h-10"
          aria-label="Ver tipo de cambio"
        >
          <ArrowUpDown className="w-4 h-4" />
          <span className="font-medium">USD</span>
        </button>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="bg-black/50 fixed inset-0 animate-overlayShow" />
        <Dialog.Content 
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-popover text-popover-foreground rounded-lg shadow-lg p-6 w-full max-w-md animate-contentShow border border-border"
          onInteractOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
        >
          <div className="flex justify-between items-center mb-4">
            <Dialog.Title className="text-xl font-bold text-foreground">
              {translator("Global.dollarRate")}
            </Dialog.Title>
            <Dialog.Close asChild>
              <button
                className="text-muted-foreground hover:text-foreground"
                aria-label="Cerrar"
              >
                <X className="w-5 h-5" />
              </button>
            </Dialog.Close>
          </div>

          {rate ? (
            <div className="space-y-4">
              <div className="flex justify-between p-4 bg-blue-50 dark:bg-blue-900/30 rounded-lg">
                <div>
                  <p className="text-sm text-muted-foreground">
                    {translator("Global.sale")} (USD → CRC)
                  </p>
                  <p className="text-2xl font-bold text-blue-600 dark:text-blue-400">
                    ₡{rate.purchase.toFixed(2)}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-muted-foreground">
                    {translator("Global.purchase")} (CRC → USD)
                  </p>
                  <p className="text-2xl font-bold text-green-600 dark:text-green-400">
                    ₡{rate.sale.toFixed(2)}
                  </p>
                </div>
              </div>

               <div className="text-sm text-muted-foreground">
            <p>
              {translator("Global.Updated")}: {rate.date || translator("Global.dateNotAvailable")}
            </p>
          </div>
        </div>
      ) : (
        <p className="text-muted-foreground py-4">
          {translator("Errors.unexpectedError")}
        </p>
      )}

          <div className="mt-6 flex justify-end">
            <Dialog.Close asChild>
              <button className="px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-colors">
                {translator("Global.close")}
              </button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
